/*!
 * American Well Online Care
 *
 * Copyright © 2021 American Well.
 * All rights reserved.
 *
 * It is illegal to use, reproduce or distribute
 * any part of this Intellectual Property without
 * prior written authorization from American Well.
 */

import { PatientFhirData } from '@app/shared/model/fhir/patient-fhir-data.model';
import { PractitionerFhirData } from '@app/shared/model/fhir/practitioner-fhir-data.model';

export class AppointmentFhirData {
  public patient: PatientFhirData;
  public practitioner: PractitionerFhirData;
  constructor() {
    this.patient = new PatientFhirData();
    this.practitioner = new PractitionerFhirData();
  }
}
